import { useEffect } from 'react';
import { reaction } from 'mobx';
import { selectLocalParticipant } from 'state/selectors';
import { roomInfoStore } from 'state/store';
import { stopScreenShareIfHardLocked } from './webinarStatus';

/** Останавливает шаринг экрана, когда в настройках вебинара включена блокировка. */
export const useWebinarForceScreenShareOff = () => {
    useEffect(
        () =>
            reaction(
                () => ({
                    screenShareDisabled: Boolean(roomInfoStore.metadata?.webinarMode?.screenShareDisabled),
                    local: selectLocalParticipant(),
                }),
                ({ local }) => {
                    if (!local) return;
                    stopScreenShareIfHardLocked(local);
                },
                { fireImmediately: true },
            ),
        [],
    );
};
